module.exports = __webpack_public_path__ + "img/wardrobe.00d3c01e.png";